<!--Translated-->
<template>
  <table class="table--type2 table--defense">
    <colgroup>
      <col class="tbl-cellproblem" />
      <col class="col-add" />
      <col class="tbl-cellproduct" />
      <col class="tbl-cellinpt" />
      <col class="tbl-cellprice" />
      <col v-if="phase.is_temporary" class="col-delete" />
    </colgroup>
    <thead>
      <tr>
        <th class="tbl-cellproblem">
          <div class="tbl_info">
            <div class="tbl_info-wrap">
              <div v-svg="{ name: 'stimulator' }"></div>
              <div class="tbl_info-celltext">
                {{ $t('ProgramTypesStimulationsTable:Header') }}
              </div>
            </div>
          </div>
        </th>
        <th class="tbl-cellproduct" colspan="2">
          {{ $t('ProgramTypesStimulationsTable:TableHeaders:0') }}
        </th>
        <th class="tbl-cellinpt">
          {{ $t('ProgramTypesStimulationsTable:TableHeaders:1') }}
        </th>
        <th class="tbl-cellprice">
          {{ $t('ProgramTypesStimulationsTable:TableHeaders:2') }}
        </th>
        <th v-if="phase.is_temporary" class="col-delete unicol-colordark">
          <div v-svg="{ name: 'delete' }"></div>
        </th>
      </tr>
    </thead>
    <template v-if="typesStimulations.length > 0">
      <RowStimulationType
        v-for="sType of typesStimulations"
        :sType="sType"
        :phase="phase"
        :key="sType.id"
        @deleteStimulationType="deleteStimulationType"
      />
    </template>
    <tbody v-else>
      <tr class="row tbl_row--active row--message">
        <td class="tbl-cellproblem" :colspan="phase.is_temporary ? 6 : 5">
          <div v-if="phase.is_temporary">
            <div class="cblock__infoblock">
              <p>
                {{
                  $t('ProgramTypesStimulationsTable:AddTypesStimulationText')
                }}
              </p>
              <Button
                :text="
                  $t('ProgramTypesStimulationsTable:AddTypesStimulationButton')
                "
                size="standart"
                color="accentlines"
                icon="plus"
                @click="$emit('addStimulationType', phase.id)"
              />
            </div>
          </div>
          <div v-else>
            {{ $t('ProgramTypesStimulationsTable:NoText') }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState } from 'vuex';
import { mutationTypes } from '@/store/modules/clientsArea/programs';
import Button from '@/components/views/Button';
import RowStimulationType from './ProgramRowStimulationType';

export default {
  name: 'UserProgramTypesStimulationsTable',
  components: {
    Button,
    RowStimulationType,
  },
  props: { phase: { type: Object, required: true } },
  computed: {
    ...mapState({
      typesStimulations(state) {
        const visibleComboTypeIds =
          state.userDefence.programTypesStimulationCombinations
            .filter((c) => c.program_phase_id === this.phase.id)
            .filter((combo) => {
              const comboProducts =
                state.userDefence.programTypesStimulationCombinationsProducts
                  .filter((p) => p.combination_id === combo.id)
                  .map((p) =>
                    state.plantsCare.products?.find(
                      ({ id }) => id === p.product_id
                    )
                  )
                  .filter(Boolean);
              const hasInactiveProduct = comboProducts.some(
                (product) => product.is_active === 0
              );
              if (!hasInactiveProduct) return true;
              return Boolean(
                combo.is_selected ||
                  state.userDefence.serverData.programTypesStimulationCombinations?.find(
                    ({ id }) => id === combo.id
                  )?.is_selected
              );
            })
            .map((c) => c.type_stimulation_id);

        return [
          ...new Set([
            ...state.userDefence.programTypesStimulationProducts
              .filter(
                ({ program_phase_id }) => this.phase.id === program_phase_id
              )
              .map(({ type_stimulation_id }) => type_stimulation_id),
            ...visibleComboTypeIds,
          ]),
        ]
          .map((typeId) =>
            state.userDefence.typesStimulation.find(({ id }) => id === typeId)
          )
          .filter(Boolean);
      },
    }),
  },
  methods: {
    deleteStimulationType(id) {
      this.$confirm({
        message: this.$t(
          'ProgramTypesStimulationsTable:ConfirmDeleteModal:Message'
        ),
        buttons: {
          left: {
            text: this.$t(
              'ProgramTypesStimulationsTable:ConfirmDeleteModal:ButtonLeft'
            ),
            icon: 'delete',
          },
          right: {
            text: this.$t(
              'ProgramTypesStimulationsTable:ConfirmDeleteModal:ButtonRight'
            ),
            icon: 'cancel',
          },
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.commit(mutationTypes.removeStimulationType, {
              id,
              phaseId: this.phase.id,
            });
          }
        },
      });
    },
  },
};
</script>
